<template>
  <div>
    <b-card class="mt-2 mb-4 shadow-sm">

      <b-row v-if="operationBilanId == null" align-h="center" class="row mx-0">
        <div class="col-md-5 text-center">
          <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="mt-4 mb-2 no-result-img"
               style="max-height: 25%;">

          <div class="main-color-text-text bold-text level-two-title">
            {{ $t('operation.bilan.emptyTitle') }}
          </div>

          <div class="main-color-text">
            {{ $t('operation.bilan.emptySubtitle.first') }}
          </div>

          <div class="main-color-text">
            {{ $t('operation.bilan.emptySubtitle.second') }}
          </div>

        </div>
      </b-row>
      <div v-else>

        <OperationBilanTable
          ref="operationBilanTable"
          :items-charges="itemsCharges"
          :items-global="itemsGlobal"
          :items-lots="itemsLots"
          :operation-name="this.operation.name"
          :table-fields-charges="tableFieldsCharges"
          :table-fields-global="tableFieldsGlobal"
          :table-fields-lots="tableFieldsLots">
        </OperationBilanTable>
      </div>
      <div class="d-flex justify-content-end">
        <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t("Back") }}</b-button>
        <b-button variant="primary" @click="next">{{ $t("Save.and.Continue") }}</b-button>
      </div>
    </b-card>
  </div>

</template>

<script>
import api from "../../../services/api";
import OperationBilanTable from "../../operationBilan/components/OperationBilanTable";

export default {
  name: "OperationShowBilan",

  components: {
    OperationBilanTable
  },

  props: {
    operationId: {
      default: null
    },
    operationBilanId: {
      default: null
    },
  },

  data() {
    return {
      bilan: true,
      operation: {
        name: null,
        id: null
      },
      tableFieldsCharges: [
        {label: '', key: 'type'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsCharges: [],

      tableFieldsLots: [
        {label: 'Lot', key: 'lot'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsLots: [],

      tableFieldsGlobal: [
        {label: 'Balance financière professionnelle', key: 'nom'},
        {label: '', key: 'taux', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'Montant', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsGlobal: [],
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {
    back() {
      this.$emit('didBack')
    },

    next() {
      this.$emit('didContinueFinancial')
    },

    async fetchData() {
      if (this.operationId) {
        await this.fetchOperation()
      }

      if (this.operationBilanId) {
        await this.fetchBilanData()
      }
    },


    async fetchBilanData() {
      api
        .get(`/operationBilan/getBilanData/${this.operationId}`)
        .then(response => {
          this.itemsCharges = response.data['itemsCharges']
          this.itemsLots = response.data['itemsLots']
          this.itemsGlobal = response.data['itemsGlobal']
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    modifyBilan() {
      this.$router.push({
        name: 'OperationBilanCreateEdit',
        params: {
          operationId: this.operationId
        }
      })
    },
    async fetchOperation() {
      api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operation.name = response.data.name
          this.operation.id = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },


    clickOnCreateBtn() {
      this.$router.push({
        name: 'OperationBilanCreateEdit',
        params: {
          operationId: this.operationId
        }
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationDossier/dossierOperationCreateSteps/DossierOperationFinancialStep.vue